module.exports = __webpack_public_path__ + "static/media/Starmus_short_video.79e13438.mp4";